<template>
  <div class="text-left position-relative" :class="{'opacity-05':new Date().setHours(0,0,0,0) > new Date(closeDay).getTime() }">
    <div class="pd-x-2 pd-y-4 list-work">
      <el-tag type="info" effect="dark" class="position-absolute secondary text-font-14"
        >งานมอบหมายที่ {{ number }}</el-tag
      >
    </div>

    <el-card
      class="box-card pd-x-3 pd-y-4 assignment-box"
      :class="{ 'show-upload': showUpload}"
      shadow="never"
    >
      <h4 class="mg-less text-font-16">
        {{ title }}
      </h4>
      <p class="mg-t-5 text-font-16">
        <viewer v-if="description && description != '<p><br></p>'" :initialValue="description" />
      </p>
      <div class="text-right pd-b-5">
        <span
          class="text-font-14"
          :class="
            new Date().setHours(0,0,0,0) > new Date(closeDay).getTime()
              ? 'color-danger'
              : 'color-gray'
          "
          ><i class="fas fa-exclamation-triangle"></i
          ><span>
            กำหนดส่งงานที่ได้รับมอบหมายวันที่ {{ new Date(closeDay).setHours(23,59,59)  | dateTimeTh }}</span
          ></span
        >
      </div>

      <div class="border-b" :class="showUpload ? 'pd-b-2' : 'pd-b-4'">
        <div v-for="(item, index) in fileList" :key="index" class="pd-t-5">
          <a
            :href="`${urlCouse}${courseId}/${item.file}`"
            class="color-primary"
            target="_blank"
          >
            <i
              :class="`fas ${getFileIcon(item.type).name} text-font-16`"
              :style="`color:${getFileIcon(item.type).color}`"
            ></i>
            <span class="text-font-12 pd-l-5">{{ item.default }}</span>
          </a>
        </div>
      </div>

      <div v-loading="loadingFile" :class="showUpload ? 'pd-t-2' : ''">
        <el-upload
          v-if="user.role == 0 && showUpload && new Date().setHours(0,0,0,0) <= new Date(closeDay).getTime()"
          class="upload-demo"
          action="#"
          multiple
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadAssignment"
        >
          <template slot="trigger">
            <div class="flex-display">
              <div class="upload-input">
                <span class="text-font-14">
                  <i class="fas fa-cloud-upload-alt"></i>
                  <span class="pd-l-5">กรุณาแนบไฟล์เพื่อส่งการบ้าน</span>
                </span>
              </div>
        
              <el-button size="small" type="primary" class="mg-l-3 pd-x-3" round
                >แนบไฟล์</el-button
              >

            </div>
          </template>
        </el-upload>
        <div v-if="new Date().setHours(0,0,0,0) > new Date(closeDay).getTime()" class="text-center">
          <p class="text-font-18 color-danger-light text-weight-bold">
            หมดเวลาส่งการบ้านแล้ว
          </p>
        </div>
        <div class="pd-t-4">
          <div
            v-for="(item, index) in fileUploadList"
            :key="index"
            class="pd-t-5 flex-display js-between"
          >
          <div>
            <p class="attach-text-over mg-less">
              <a
                :href="`${urlFile}${createdBy}/${item.file}`"
                class="color-primary"
                target="blank"
              >
                <i
                  :class="`fas ${getFileIcon(item.type).name} text-font-16`"
                  :style="`color:${getFileIcon(item.type).color}`"
                ></i> 
              <span class="text-font-12 pd-l-5">{{ item.default }}</span>
              </a>
            </p>
              <span
                v-if="user.role == 0"
                @click="delAssignment(item.id,item.file)"
                class="mg-l-5 color-gray-lighter text-font-12 cursor-pointer"
              >
                <i class="fas fa-times-circle"></i>
              </span>
          </div>
            <div class="flex-display ai-center">
              <span style="color:#00B27D;" class="text-font-12 mg-r-4"><i class="fas fa-check"></i> ส่งเรียบร้อย</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getFileIcon } from "@/service/file";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

import { Viewer } from "@toast-ui/vue-editor";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    viewer: Viewer,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    subjectId: {
      type: String,
      default() {
        return "";
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    userId: {
      type: String,
      default() {
        return "";
      },
    },
    number: {
      type: Number,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default() {
        return "";
      },
    },
    description: {
      type: String,
      default() {
        return "";
      },
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    showUpload: {
      type: Boolean,
      default() {
        return true;
      },
    },
    closeDay: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      fileUploadList: [],
      loadingFile: false,
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      urlFile: process.env.VUE_APP_BASE_URL_FILE,
      createdBy: "",
    };
  },
  mounted() {
    this.fetchTakes();
  },
  methods: {
    fetchTakes() {

      let obj = {
        courseId: this.courseId,
        userId: (this.user.role >= 50) ? this.userId : "",
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/takes`, obj)
        .then((res) => {
   
          if (res.data.success) {
            let subjects = res.data.obj.subjects.filter(
              (filter) => filter.subjectId == this.subjectId
            );

            if (subjects.length > 0) {
              let filter = subjects[0].assignment.filter(
                (filter) => filter.actionTo == this.id
              );
     
              if (filter.length > 0) {
                this.fileUploadList = []
                filter[0].attachAssignment.map((item)=>{
                    this.fileUploadList.push({
                      default: item.default,
                      file: item.file,
                      type: item.type,
                      id:filter[0]._id
                    })
                })
                this.createdBy = filter[0].createdBy;
              } else {
                this.fileUploadList = [];
              }
            }
          }
        })
        .finally(() => {});
    },
    delAssignment(id,file){
      this.loadingFile = true;

      let obj={
        takeId:id,
        file:file
      }
 
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/take/assignment`,obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchTakes();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delAssignment error", e);
        })
        .finally(() => {
          this.loadingFile = false;
        });
    },
    uploadAssignment(file) {
      this.loadingFile = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("type", "assignment");
      formData.append("actionId", this.id);
      formData.append("actionTo", this.id);
      formData.append("courseId", this.courseId);
      formData.append("subjectId", this.subjectId);
      formData.append("choiceId", "");
      formData.append("suggestion", "");
      formData.append("latestTime", 0);
      formData.append("watched", []);
      formData.append("attachAssignment", file.raw);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`take`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.fetchTakes();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("uploadAssignment error", e);
        })
        .finally(() => {
          this.loadingFile = false;
        });
    },
  },
};
</script>

<style scoped>
.assignment-box {
  min-height: 260px;
  /* overflow-y: auto; */
}
.assignment-box.show-upload {
  min-height: 360px;
}
@media (max-width: 991.98px) {
  .assignment-box {
    height: auto!important;
    min-height: auto !important;
  }
}
</style>
